<template>
<div class="row">
  <div class="Absolute-Center is-Responsive">
    <div id="logo-container"></div>
    <div v-if="isLoading" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-if="isLoading">Registering you to application... Please Wait</div>
    <div v-if="!isLoading" class="col-sm-12">
      <div class="row">
      <div class="form-group col-md-12">
        <input type="email" class="form-control" id="app-email-address" aria-describedby="emailHelp" placeholder="Email" v-model="body.email">
      </div>
      </div>
      <div class="row">
      <div class="form-group col-md-12">
        <input type="password" @keyup.enter="login" class="form-control" id="exampleInputPassword1" placeholder="Password" v-model="body.password">
      </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <input type="text" class="form-control" id="app-first-name" placeholder="First Name" v-model="body.firstName">
        </div>
        <div class="form-group col-md-6">
          <input type="text" class="form-control" id="app-last-name" placeholder="Last Name" v-model="body.lastName">
        </div>
      </div>
      <div class="row">
      <div class="form-group col-md-12">
        <input type="text" class="form-control" id="app-phone-number" placeholder="Phone Number" v-model="body.phoneNumber">
      </div>
      </div>
      <button class="btn btn-primary btn-block" @click="save">Sign me Up!</button> 
      <router-link to="login" style="color: blue">bring me back to login</router-link>
    </div>  
  </div>    
</div>
</template>

<script>
import api from '../services/api'
import { SignUp } from '../models/signup'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      body: SignUp,
    }
  },
  computed: {
    ...mapState(['isLoading'])
  },
  methods: {
    ...mapActions(['appLogin', 'appLoading']),
    async save() {
      this.appLoading(true)
      const signUpApi = api('member-management')
      const registered = await signUpApi.createWithResultAndToast(this.body)
      if (registered.ok) {
        this.$router.go(-1)
      }
      this.appLoading(false)
    },
    login() {
      this.$router.push({ name: 'login' })
    },
  }
}
</script>